import { useState } from "react";

import { Outlet } from "react-router-dom";
import { useSiteContext } from "../../contexts/SiteProvider";
import Header from "./Header";
import "./MainLayout.scss";
import "./MainTheme.scss";
import SideNav from "./SideNav";
import { motion } from "framer-motion";

const Layout = () => {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [isDark, setIsDark] = useState<boolean>(true);
  const { user,title } = useSiteContext();

  const toggleSidebar = () => {
    setIsOpen(!isOpen); // Toggle the state
  };

  return (
    <>
   
   <motion.div
    className={`container is-fluid p-0 sds-container ${!isDark ? "smart-hims-container" : ""}`}
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.6 }}
  >
      <div className={`sds-main-sidenav ${isOpen ? "expanded" : ""}`}>

        <SideNav isOpen={isOpen}   setIsOpen={(value) => setIsOpen(value)} />

      </div>
      {isOpen && (
        <div
          className="sds-mobile-backdrop show"
          onClick={() => setIsOpen(false)}
        />
      )}
     
      <motion.div
  className={`sds-main-header ${isOpen ? "expanded" : ""}`}
  initial={{ x: 0 }}
  animate={{ x: isOpen ? 0 : 0 }} // Moves header when sidebar opens
  transition={{ duration: 0.4, ease: "easeInOut" }}
>
          <Header
            setIsOpen={(value) => setIsOpen(value)}
            isOpen={isOpen}
            setIsDark={setIsDark}
            isDark={isDark}
            title={title}
          />
        </motion.div>
        <div className={` sds-main-content ${isOpen ? "expanded" : ""}`}>
        <div className={`sds-main-div `}>
          <div className="sds-main-inner"><Outlet /></div>
        </div>
      </div>

    </motion.div>

  </>
  );
};

export default Layout;
